import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import AllFieldsCode from "!!raw-loader!./forms/AllFields.tsx";
import AllFields from "./forms/AllFields";
import StandaloneFieldsCode from "!!raw-loader!./forms/StandaloneFields.tsx";
import StandaloneFields from "./forms/StandaloneFields";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Form Fields", AllFieldsCode, AllFields),
		paneComponent("Standalone Fields", StandaloneFieldsCode, StandaloneFields),
	];

	return (
		<Pane
			components={components}
			imports='import {Checkbox, DatePicker, FormControlLabel, MultiSelect, SingleSelect, Text, TextField} from "designSystem/index";'
			muiApi="form"
			muiComponent="forms"
			{...props}
		/>
	);
};